export default "__VITE_ASSET__BmHIeSgV__"